const prefetched = new Set<string>();

const ROUTE_IMPORTS: Record<string, () => Promise<unknown>> = {
  '/hr/attendance': () =>
    Promise.all([
      import('@/modules/hr/attendance/HrAttendancePage'),
      import('@/modules/hr/attendance/HrAttendancePageContent'),
      import('@/modules/hr/attendance/HrAttendancePageBody'),
    ]),
  '/hr/shifts': () => import('@/modules/hr/shifts/HrShiftsPage'),
  '/hr/employees': () => import('@/modules/hr/employees/HrEmployee360Page'),
  '/hr': () => import('@/modules/hr/dashboard/HrDashboardPage'),
};

/** Warm the lazy chunk for a route (safe to call repeatedly). */
export function prefetchRoute(to: string): void {
  const pathname = to.split('?')[0].split('#')[0];
  if (!pathname || prefetched.has(pathname)) return;
  const load = ROUTE_IMPORTS[pathname];
  if (!load) return;
  prefetched.add(pathname);
  void load();
}
